import { MapPin, Phone, Instagram, Clock, MessageCircle } from "lucide-react";
import { CONTATO } from "@/content/site";

const Row = ({ icon: Icon, children, testid }) => (
  <div className="flex items-start gap-4" data-testid={testid}>
    <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center border border-brand/40 text-brand">
      <Icon size={15} />
    </span>
    <div className="text-sm font-light leading-relaxed text-stone-300">{children}</div>
  </div>
);

const ContactInfo = ({ mensagemWhats = "Olá! Vim pelo site da NB Imóveis e gostaria de mais informações." }) => (
  <div className="space-y-6">
    <Row icon={MapPin} testid="contact-info-address">
      {CONTATO.endereco}
      <br />
      {CONTATO.bairro}, {CONTATO.cidade}/{CONTATO.estado}
      <br />
      <span className="text-stone-500">CEP {CONTATO.cep}</span>
    </Row>
    <Row icon={Phone} testid="contact-info-phone">
      <a href={`tel:+${CONTATO.whatsapp}`} className="transition-colors duration-300 hover:text-brand">
        {CONTATO.telefone}
      </a>
    </Row>
    <Row icon={Instagram} testid="contact-info-instagram">
      <a href={CONTATO.instagramUrl} target="_blank" rel="noopener noreferrer" className="transition-colors duration-300 hover:text-brand">
        {CONTATO.instagram}
      </a>
    </Row>
    <Row icon={Clock} testid="contact-info-hours">{CONTATO.horario}</Row>
    <a
      href={`https://wa.me/${CONTATO.whatsapp}?text=${encodeURIComponent(mensagemWhats)}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="contact-info-whatsapp-cta"
      className="group mt-2 inline-flex items-center gap-3 bg-brand px-7 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-brand-light"
    >
      <MessageCircle size={15} /> Chamar no WhatsApp
    </a>
  </div>
);

export default ContactInfo;
